export default __webpack_public_path__ + "static/business-owners-db857c312dfcf2d17901146c94aaed9c.png";